<template>
  <a-config-provider :locale="locale" v-if="!loading">
    <!-- 页头 -->
    <navroot :class="{ 'phone-mode': phoneMode }"></navroot>
    <div id="content" :class="{ 'phone-mode': phoneMode }">
      <router-view />
    </div>
    <phoneBar v-if="phoneMode"></phoneBar>
  </a-config-provider>
</template>

<script>
//汉化
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

import headPath from '@/filter/headPath';
import navroot from "@/component/public/nav/nav.vue";
import phoneBar from "@/component/public/phone-bar/phone-bar.vue";
import { PASSPORT_CLIENT_SERVER, LESSONPLAY_TOKEN, LOGINURL } from './config/url';

export default {
  name: "App",
  data() {
    return {
      token: '',
      loading: true,
      locale: zhCN,
      phoneMode: false,

      catalog_list: [],
    }
  },
  components: {
    navroot, phoneBar
  },
  mounted() {
    this.judgeToken();

    this.judgePhone();
    window.addEventListener('resize', this.judgePhone);
  },
  methods: {
    //判断手机端
    judgePhone() {
      let w_width = window.innerWidth;
      let phoneMode = w_width < 700;
      if (this.phoneMode == phoneMode) return;

      this.phoneMode = phoneMode;
      this.$store.commit("phoneMode", this.phoneMode);
    },
    //判断token
    async judgeToken() {
      //const token = process.env.NODE_ENV === 'development' ? 'development' : window.localStorage.getItem(LESSONPLAY_TOKEN);
      const token = window.localStorage.getItem(LESSONPLAY_TOKEN);
      const herfurl = location.href.split("?")[0];
      //localStorage中不存在token时，先尝试从URL中获取token
      if (!token) {
        const urlToken = this.getURLToken();
        //URL中也不存在token，跳转到认证中心检查（其他应用）是否已经登录过
        if (!urlToken) {
          location.href = `${PASSPORT_CLIENT_SERVER}/inner-training?redirectURI=${herfurl}`;
        }

        //URL中存在token，验证该token的有效性（这种情况一般发生在首次登录）
        else {
          const ret = await this.$api.passport.verifyToken(urlToken)
          this.deleteURLToken();
          //URL中的token有效，将该token写入localStorage并删除URL中的token
          if (ret.status === 1) {
            window.localStorage.setItem(LESSONPLAY_TOKEN, urlToken)

            this.userGuid = ret.userGuid;
            this.token = ret.token;
          }
          //URL中的token无效，删除URL中的token并跳转到登录页（这种情况一般是用户手动在URL后面添加了token参数）
          else location.href = `${LOGINURL}?redirectURI=${herfurl}`;
        }
      }

      //localStorage中存在token时，验证该token的有效性
      else {
        const ret = await this.$api.passport.verifyToken(token)
        //localStorage中的token有效
        if (ret.status === 1) {
          this.userGuid = ret.userGuid;
          this.token = ret.token;
        }
        //localStorage中的token无效，清除该token并跳转到认证中心检查（其他应用）是否已经登录过
        else {
          window.localStorage.removeItem(LESSONPLAY_TOKEN)
          location.href = `${PASSPORT_CLIENT_SERVER}/inner-training?redirectURI=${herfurl}`;
        }
      }
      this.loadFunction();
    },
    //删除URL中的token
    deleteURLToken() {
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete('token');
      const newURL = searchParams.toString() ? `${location.pathname}?${searchParams.toString()}` : location.pathname
      history.pushState({}, '', newURL);
    },
    //获取URL中的token
    getURLToken() {
      const search = new URLSearchParams(location.search);
      const urlToken = search.get('token');
      return urlToken;
    },
    //加载方法
    async loadFunction() {
      //获取类型列表
      let catalog_list = [];
      let catalog_data = await this.$api.digitalBook.getDigitalBookType().then(res => res.data);
      if (catalog_data) catalog_list = catalog_data.list;
      catalog_list.unshift({ name: '所有课程' });

      //获取数字教材
      let digitalBookList = await this.$api.digitalBook.getDigitalBookList().then(res => res.data || []);

      //判断用户是否加入班级
      let allMyClass = await this.$api.digitalBook.joinList(this.userGuid).then(res => res.data || []);

      digitalBookList.forEach(course => {
        course.userStatus = 'nojoin';
        allMyClass.forEach(item => {
          if (course.ClassList?.indexOf(item.FK_ClassGuid) > -1) course.userStatus = 'nofinish';
        })
      })

      this.$store.commit("catalogList", catalog_list);
      this.$store.commit("digitalBookList", digitalBookList);

      this.getUserInfo();
    },
    async getUserInfo() {
      let userGuid = this.userGuid;
      if (!userGuid) return location.href = `${LOGINURL}?redirectURI=${herfurl}`;

      //获取所有成就
      let allAchievementList = await this.$api.unifydata.getAllAchievement().then(res => res.data || []);
      this.$store.commit('allAchievementList', allAchievementList);

      //获取用户信息
      let user = await this.$api.unifydata.getStudent({ userGuid }).then(res => res.data);
      if (user) {
        user.NickName = user.NickName || user.Name;
        user.token = this.token;
        user.HeadPhotoPath = headPath(user.HeadPhotoPath);
      }
      this.$store.commit('userInfo', user);

      //获取vip身份
      let studentVip = await this.$api.payorder.getStudentVip(userGuid).then(res => res.data || null);
      if (studentVip) {
        let content = studentVip.content ? JSON.parse(studentVip.content) : [];
        this.$store.commit("studentVip", content);
      }
      this.loading = false;
    }
  }
}
</script>

<style></style>
